import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withLogger } from 'shell/hoc/withLogger';

import { setRecentSearch, getRecentSearches } from 'utils';

import ClientsInfiniteScrollList from './ClientInfiniteScrollList';
import styles from './ClientInfiniteScrollList.styles';

import { clearClientsCache } from '../../modules/clients/actions';

const mapStateToProps = ({ clientsModule, clientingModule }) => ({
  clientsStats: clientsModule.clientsList.stats,
  recentSearchList: getRecentSearches(),
  setRecentSearch,
  loading: clientsModule.clientsList.infiniteListLoading,
  customerFilterParams: clientsModule.clientsList.customerFilterParams,
  clients: clientsModule.clientsList.clients,
  isInboxLoading: clientingModule.inbox.isLoading,
});

const mapDispatchToProps = {
  clearClientsCache,
};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withLogger(),
)(ClientsInfiniteScrollList);
